import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { GtagService } from "../../gtag/gtag.service";
import { AuthService } from "../auth.service";


@Component({
    selector: 'app-needpay',
    templateUrl: './needpay.component.html',
    styleUrls: ['./needpay.component.css'],
    standalone: false
})
export class NeedPayComponent implements OnInit {

    constructor(private authService: AuthService, private router: Router, private gtag: GtagService) {
        this.gtag.pageview2('Need payment');
    }

    ngOnInit() {
        // setTimeout(() => {
        //     this.router.navigate(['/']);
        // }, 5000);
    }
}